import React from "react";
import clsx from "clsx";
import { NavLink } from "react-router-dom";
import { Grid } from "@mui/material";
import { Card, Stack } from "@curves/ui-base";
import { MembershipProgressBar } from "@icoach/members/components/";
import CommonTabs from "@icoach/components/layout/CommonTabs";
import { MEMBERS_MEMBER_DETAIL_TABS } from "@icoach/constants";
import { WorkoutMetrics, MemberAvatarEditor, MemberHealthCareIconButton, MemberLineBindingIconButton } from "@icoach/memberDetail/components";
import { CLUB_MEMBERS_ROUTER } from "@icoach/router/routerPath";
import { MemberInfoCard, EditableInfo } from "@icoach/components";
import useMenusControlled from "@util/hook/useMenusControlled";

const MemberDetailSummary = props => {
	const { className, sourceData: memberProfile, memberID, activeTab } = props;
	const {
		membershipBar = {},
		membershipText,
		memberName,
		nickName,
		memberNo,
		picturePath,
		membershipStatus,
		totalWorkoutQuantity,
		weeklyWorkoutQuantity,
		monthlyWorkoutQuantity,
		resource,
	} = memberProfile || {};
	
	const {
		isShowBindingQrCode,
	} = resource || {};

	const tabData = useMenusControlled([
		{
			label: "運動紀錄",
			frontKey: "C2X03",
			value: MEMBERS_MEMBER_DETAIL_TABS.WORKOUT,
			component: NavLink,
			to: CLUB_MEMBERS_ROUTER.MEMBER_DETAIL.GET_TABS_PATH(memberID, MEMBERS_MEMBER_DETAIL_TABS.WORKOUT)
		},
		{
			label: "會員管理",
			frontKey: "C2X03",
			value: MEMBERS_MEMBER_DETAIL_TABS.BASIC,
			component: NavLink,
			to: CLUB_MEMBERS_ROUTER.MEMBER_DETAIL.GET_TABS_PATH(memberID, MEMBERS_MEMBER_DETAIL_TABS.BASIC)
		},
		{
			label: "會籍管理",
			frontKey: "C2X03",
			value: MEMBERS_MEMBER_DETAIL_TABS.MEMBERSHIP,
			component: NavLink,
			to: CLUB_MEMBERS_ROUTER.MEMBER_DETAIL.GET_TABS_PATH(memberID, MEMBERS_MEMBER_DETAIL_TABS.MEMBERSHIP)
		},
		{
			label: "量身紀錄",
			frontKey: "C8X01",
			value: MEMBERS_MEMBER_DETAIL_TABS.INBODY,
			component: NavLink,
			to: CLUB_MEMBERS_ROUTER.MEMBER_DETAIL.GET_TABS_PATH(memberID, MEMBERS_MEMBER_DETAIL_TABS.INBODY)
		},
		{
			label: "聯繫紀錄",
			frontKey: "C2X03",
			value: MEMBERS_MEMBER_DETAIL_TABS.CONTACT_RECORD,
			component: NavLink,
			to: CLUB_MEMBERS_ROUTER.MEMBER_DETAIL.GET_TABS_PATH(memberID, MEMBERS_MEMBER_DETAIL_TABS.CONTACT_RECORD)
		},
		{
			label: "健康商品",
			frontKey: "C2X03",
			value: MEMBERS_MEMBER_DETAIL_TABS.HC,
			component: NavLink,
			to: CLUB_MEMBERS_ROUTER.MEMBER_DETAIL.GET_TABS_PATH(memberID, MEMBERS_MEMBER_DETAIL_TABS.HC)
		},
		{
			label: "租櫃紀錄",
			frontKey: "C2X06",
			value: MEMBERS_MEMBER_DETAIL_TABS.RENT_CABINET,
			component: NavLink,
			to: CLUB_MEMBERS_ROUTER.MEMBER_DETAIL.GET_TABS_PATH(memberID, MEMBERS_MEMBER_DETAIL_TABS.RENT_CABINET)
		},
		{
			label: "智能系統",
			frontKey: "C2X07",
			value: MEMBERS_MEMBER_DETAIL_TABS.SMARTFITNESSBAND,
			component: NavLink,
			to: CLUB_MEMBERS_ROUTER.MEMBER_DETAIL.GET_TABS_PATH(memberID, MEMBERS_MEMBER_DETAIL_TABS.SMARTFITNESSBAND)
		},
		{
			label: "其他",
			frontKey: "C2X03",
			value: MEMBERS_MEMBER_DETAIL_TABS.OTHER,
			component: NavLink,
			to: CLUB_MEMBERS_ROUTER.MEMBER_DETAIL.GET_TABS_PATH(memberID, MEMBERS_MEMBER_DETAIL_TABS.OTHER)
		}
	]);

	return (
		<Card className={clsx("member-summary-box", className)}>
			<Card.CardContent className="px-3 pt-3 pb-2">
				<Stack alignItems="start" justifyContent="start">
					<Stack direction="column" justifyContent="center" alignItems="center" className="mr-4">
						<MemberAvatarEditor memberID={memberID} memberName={memberName}
											membershipStatus={membershipStatus} picturePath={picturePath} />
						<Stack direction="row" justifyContent="center" alignItems="center" spacing={1}>
							<MemberHealthCareIconButton referenceID={memberID} />
							{isShowBindingQrCode && <MemberLineBindingIconButton referenceID={memberID} />}
						</Stack>
						
					</Stack>
					<Grid container spacing={2}>
						<Grid item xs={4}>
							<MemberInfoCard className="mb-2" name={memberName} nickname={nickName} memberNo={memberNo}
											isShowAvatar={false} />
						</Grid>
						<Grid item xs={8}>
							<WorkoutMetrics weeklyWorkoutQuantity={weeklyWorkoutQuantity}
											monthlyWorkoutQuantity={monthlyWorkoutQuantity}
											totalWorkoutQuantity={totalWorkoutQuantity} />
						</Grid>
						<Grid item xs={12}>
							<MembershipProgressBar progressBarData={membershipBar} />
						</Grid>
						<Grid item xs={12}>
							<EditableInfo label="會籍類別">{membershipText}</EditableInfo>
						</Grid>
					</Grid>
				</Stack>
			</Card.CardContent>
			<CommonTabs tabs={tabData} activeTab={activeTab} variant="scrollable" scrollButtons="auto"
						className="px-1" />
		</Card>
	);
};

export default MemberDetailSummary;
